import { queryOptions, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import type { ServerResponse, Template, TemplateShort } from '../../@types/types';
import { getRequestAuthPayload } from '../helpers/getRequestAuth';

import type { QueryFactory } from './factory.types';

export const fetchTemplate = async (id: string): Promise<ServerResponse<Template>> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: `/templates/${id}`,
  });

  const response = await axios(networkPayload);
  return response.data;
};

export const fetchTemplates = async (): Promise<TemplateShort[]> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: '/templates',
  });

  const response = await axios(networkPayload);
  return response.data;
};

export const fetchTemplatesCSVDownloadUrl = async (): Promise<string> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: '/templates',
    params: { format: 'csv' },
  });

  const response = await axios<{ downloadUrl: string }>(networkPayload);
  return response.data.downloadUrl;
};

export const templateQueries = {
  list: () =>
    queryOptions({
      queryKey: ['templates', 'list'] as const,
      queryFn: fetchTemplates,
    }),
  detail: (id: string) =>
    queryOptions({
      queryKey: ['templates', 'detail', id] as const,
      queryFn: () => fetchTemplate(id),
    }),
} satisfies QueryFactory;

export function useTemplates() {
  return useQuery(templateQueries.list());
}
